import React, { useState } from 'react';
import { Input, Button, Text, makeStyles, tokens } from '@fluentui/react-components';
import { useIsMobile } from '../hooks/useIsMobile';

interface StartingBalanceBarProps {
  currentValue: number;
  onUpdate: (balance: number) => void;
}

const useStyles = makeStyles({
  bar: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    backgroundColor: tokens.colorNeutralBackground3,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalXL,
    paddingRight: tokens.spacingHorizontalXL,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  mobileBar: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    backgroundColor: tokens.colorNeutralBackground3,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
});

export const StartingBalanceBar: React.FC<StartingBalanceBarProps> = ({ currentValue, onUpdate }) => {
  const styles = useStyles();
  const isMobile = useIsMobile();
  const [value, setValue] = useState(String(currentValue));

  const handleSet = () => {
    const num = parseFloat(value);
    if (!isNaN(num)) onUpdate(num);
  };

  if (isMobile) {
    return (
      <div className={styles.mobileBar}>
        <Text size={200} weight="semibold">Start: $</Text>
        <Input
          type="number"
          value={value}
          onChange={(e, data) => setValue(data.value)}
          onKeyDown={e => { if (e.key === 'Enter') handleSet(); }}
          style={{ width: '110px', textAlign: 'right' }}
          size="small"
        />
        <Button appearance="primary" size="small" onClick={handleSet}>
          Set
        </Button>
      </div>
    );
  }

  return (
    <div className={`${styles.bar} starting-balance-bar`}>
      <Text size={200} weight="semibold">Starting Balance: $</Text>
      <Input
        type="number"
        value={value}
        onChange={(e, data) => setValue(data.value)}
        onKeyDown={e => { if (e.key === 'Enter') handleSet(); }}
        style={{ width: '140px', textAlign: 'right' }}
        size="small"
      />
      <Button appearance="primary" size="small" onClick={handleSet}>
        Set
      </Button>
    </div>
  );
};
